import { fun_PostAction, fun_GetAction } from "@/api/index";
// 引入证书详情页面
import RegPersonReginfoDetails from "@/views/page/userRegister/regPersonReginfo/details/index.vue";
// 引入附件上传页面
import CorpPictureinfor from "@/views/page/components/pictureinfor/index.vue";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 弹窗状态
      detailDialogVisible: false,
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        regType: null, // 证书类型
        regLevel: null, // 证书等级
        certNum: null // 证书编号
      },
      // 查询表单
      formSearchList: [
        {
          label: "证书类型：",
          type: "select",
          value: "regType",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/DictionaryCombobox",
            zdid: "201507131626360048"
          }
        },
        {
          label: "证书等级：",
          type: "select",
          value: "regLevel",
          placeholder: "请输入",
          queryParams: {}
        },
        {
          label: "证书编号：",
          type: "input",
          value: "certNum",
          placeholder: "请输入",
          clearable: true
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "证书类型",
          prop: "regTypeName"
        },
        {
          label: "状态",
          slotName: "state",
          width: 100
        },
        {
          label: "证书等级",
          prop: "regLevelName"
        },
        {
          label: "证书专业",
          prop: "regTradeType"
        },
        {
          label: "证书编号",
          prop: "certNum"
        },
        {
          label: "发证日期",
          prop: "awardDate",
          width: 120
        },
        {
          label: "发证单位",
          prop: "awardDepart"
        },
        {
          label: "证书有效期",
          prop: "effectDate",
          width: 120
        },
        {
          label: "操作",
          slotName: "operation",
          width: 180
        }
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [], // 勾选数组
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
      controllerFlg: null, // 页面类型
      regBasicinfoId: null, // 注册人员主键
      corpName: null // 所属企业
    };
  },
  // 接收父组件传递的数据
  props: {},
  // 注册组件
  components: {
    // 证书详情
    RegPersonReginfoDetails,
    // 附件上传一览
    CorpPictureinfor
  },

  // 模板编译完成
  mounted() { },
  // 自定义方法
  methods: {
    // 打开弹框时调用
    async fun_GetOpen() {
      // 打开loading
      this.loading = true;
      // 注册人员主键不为空
      if (this.regBasicinfoId != null && this.regBasicinfoId != "") {
        // 如果是注册用户
        if ("注册用户" == this.userFlag) {
          // 如果操作类型是不详情
          if (this.controllerFlg != "details") {
            // 设置表头
            this.btnList = [
              {
                name: "添加",
                type: "success",
                icon: "document-add"
              },
              {
                name: "修改",
                type: "primary",
                icon: "edit"
              },
              {
                name: "删除",
                type: "danger",
                icon: "delete"
              }
            ];
          }
        }
        // 查询一览数据
        this.fun_GetList();
      }
    },

    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 请求，获取结果集
        let res = await fun_PostAction("/regPersonReginfo/list", {
          ...this.form,
          ...this.reqPageData,
          regBasicinfoId: this.regBasicinfoId // 注册人员主键信息
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          this.fun_Add();
          break;
        case "修改":
          this.fun_Edit();
          break;
        case "删除":
          this.fun_Del();
          break;
        default:
      }
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 下拉框点击事件
     */
    fun_GetSelectVal(e, i) {
      // 证书类型
      if (i === "regType") {
        // 赋值
        this.form.regType = e;
        // 遍历
        this.formSearchList.map(j => {
          // 如果是证书等级
          if (j.value === "regLevel") {
            // 修改下拉框请求参数，重新赋值
            j.queryParams = {
              url: "/regTradeLevel/RegTradeLevelCombobox",
              tradeType: this.form.regType
            };
          }
        });
      }
      // 证书等级
      else if (i === "regLevel") {
        // 赋值
        this.form.regLevel = e;
      }
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Details(e) {
      // 打开详情页面弹框
      this.detailDialogVisible = true;
      // 回调函数
      this.$nextTick(() => {
        // 设置弹框页面类型
        this.$refs.regPersonReginfoDetails.controllerFlg = "details";
        // 设置弹框页面注册人员证书主键
        this.$refs.regPersonReginfoDetails.form.id = e.id;
        // 设置弹框页面注册人员主键
        this.$refs.regPersonReginfoDetails.form.regBasicinfoId =
          e.regBasicinfoId;
        // 打开弹框时调用
        this.$refs.regPersonReginfoDetails.fun_GetOpen();
      });
    },
    /**
     * 点击新增按钮
     */
    fun_Add() {
      // 打开详情页面弹框
      this.detailDialogVisible = true;
      // 回调函数
      this.$nextTick(() => {
        // 设置弹框页面类型
        this.$refs.regPersonReginfoDetails.controllerFlg = "insert";
        // 设置弹框页面注册人员主键
        this.$refs.regPersonReginfoDetails.form.regBasicinfoId = this.regBasicinfoId;
        // 设置所属企业
        this.$refs.regPersonReginfoDetails.form.corpBasicinfoName = this.corpName;
        // 打开弹框时调用
        this.$refs.regPersonReginfoDetails.fun_GetOpen();
      });
    },
    /**
     * 点击修改按钮
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          // 打开详情页面弹框
          this.detailDialogVisible = true;
          // 回调函数
          this.$nextTick(() => {
            // 设置弹框页面类型
            this.$refs.regPersonReginfoDetails.controllerFlg = "update";
            // 设置弹框页面注册人员证书主键
            this.$refs.regPersonReginfoDetails.form.id = this.multipleSelection[0].id;
            // 设置弹框页面注册人员主键
            this.$refs.regPersonReginfoDetails.form.regBasicinfoId = this.multipleSelection[0].regBasicinfoId;
            // 打开弹框时调用
            this.$refs.regPersonReginfoDetails.fun_GetOpen();
          });
        }
      }
      // 如果未进行勾选
      else {
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 删除
     */
    fun_Del() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键集合
        let keys = [];
        // 遍历勾选
        for (const index in this.multipleSelection) {
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 请求，获取结果集
          fun_PostAction("/regPersonReginfo/delete", {
            keys: keys
          }).then(res => {
            // 解构res.data
            const { msg } = res.data;
            // 操作成功
            this.$message.success(msg);
            // 刷新当前页面
            this.fun_GetOpen();
          });
        });
      }
      // 如果未进行勾选
      else {
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 查看文件
     */
    fun_GetPictureinfor(e) {
      // 打开弹窗
      this.$refs.corpPictureinfor.dialogVisible = true;
      // 赋值数据编号
      this.$refs.corpPictureinfor.form.recordNumber = e.id;
      // 打开弹框时调用
      this.$refs.corpPictureinfor.fun_GetOpen();
    }
  }
};
